import {
	API_ERROR,
	PURCHASE_ORDER_LIST,
	PURCHASE_ORDER_LIST_SUCCESS,
	TOGGLE_ITEM_MENU,
	SET_PARAMS,
	FILTER_INPUT_CHANGEVALUE,
	FILTER_SELECT_CHANGEVALUE,
	PURCHASE_ORDER_ROW_DATA,
	PURCHASE_ORDER_ROW_DATA_SUCCESS,
	LIST_LAYOUT,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	PDF_DOWNNLOAD,
	MR_CODE_DETAILS,
	MR_CODE_DETAILS_SUCCESS,
	PI_CODE_DETAILS,
	PI_CODE_DETAILS_SUCCESS,
	PO_ITEM_ACKNOWLEDGE_OPEN,
	PO_ITEM_ACKNOWLEDGE_CLOSE,
	PO_ITEM_INPUT_CHANGEVALUE,
	PO_ITEM_ACKNOWLEDGE,
	PURCHASE_ORDER_CLOSE,
	PURCHASE_ORDER_FOUCS_POST,
	PO_CLOSE_MODAL_OPEN,
	PO_CLOSE_MODAL_CLOSE,
	PO_CLOSE_DESCRIPTION,
	TOGGLE_EDIT,
	HANDLE_BASE_PRICE,
	ORDER_DISC_PERCENT_CHANGEVALUE,
	ITEM_GROSS_VAL_CHANGEVALUE,
	ORDER_BASEPRICE_CHANGEVALUE,
	ORDER_TAXTYPE_CHANGEVALUE,
	ORDER_TAX_CHANGEVALUE,
	SUBMIT_EDIT_ORDER,
	VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE,
	VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE,
	PURCHASEREQUEST_ROW_DATA,
	ITEM_TIME_LINE,
	SUBMIT_EDIT_ORDER_SUCCESSFULL,
	TOGGLE_EDIT_WITH_VALUE,
	PO_HISTORY,
	PO_HISTORY_SUCCESS,
	PO_AUTHORIZATION,
	PO_AUTHORIZATION_SUCCESS,
} from "./actionTypes";
export const getPurchaseOrderList = (data) => {
	return {
		type: PURCHASE_ORDER_LIST,
		payload: { data },
	};
};
export const PurchaseOrderListSuccessful = (response) => {
	return {
		type: PURCHASE_ORDER_LIST_SUCCESS,
		payload: response,
	};
};
export const GetPoAuthorizationStatus = (data) => {
	return {
		type: PO_AUTHORIZATION,
		payload: {data},
	};
};
export const GetPoAuthorizationStatusSuccessful = (response) => {
	return {
		type: PO_AUTHORIZATION_SUCCESS,
		payload: response,
	};
};
export const toggleItemMenu = (id) => {
	return {
		type: TOGGLE_ITEM_MENU,
		payload: id,
	};
};
export const getReqestRowDetails = (id, timeLine = false) => {
	return {
		type: PURCHASEREQUEST_ROW_DATA,
		payload: { id, timeLine },
	};
};
export const getPurchaseOrderHistory = (params) => {
	return {
		type: PO_HISTORY,
		payload: params,
	};
};
export const PurchaseOrderHistorySuccessful = (response) => {
	return {
		type: PO_HISTORY_SUCCESS,
		payload: response.poitemshistory,
	};
};
export const SetParams = (params) => {
	return {
		type: SET_PARAMS,
		payload: params,
	};
};
export const FilterChangeValue = ({ key, value }) => {
	return {
		type: FILTER_INPUT_CHANGEVALUE,
		payload: { key, value },
	};
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
	return {
		type: FILTER_SELECT_CHANGEVALUE,
		payload: { key, label, key2, value },
	};
};
export const getPurchaseOrderRowData = (poId, timeLine = false) => {
	return {
		type: PURCHASE_ORDER_ROW_DATA,
		payload: { poId, timeLine },
	};
};
export const PurchaseOrderRowDataSuccessful = (response) => {
	return {
		type: PURCHASE_ORDER_ROW_DATA_SUCCESS,
		payload: response,
	};
};
export const getMRCodeDetails = (ItemId) => {
	return {
		type: MR_CODE_DETAILS,
		payload: { ItemId },
	};
};
export const getMRCodeDetailsSuccessful = (response) => {
	return {
		type: MR_CODE_DETAILS_SUCCESS,
		payload: response,
	};
};
export const getPICodeDetails = (ItemId, qitemID) => {
	return {
		type: PI_CODE_DETAILS,
		payload: { ItemId, qitemID },
	};
};
export const getPICodeDetailsSuccessful = (response) => {
	return {
		type: PI_CODE_DETAILS_SUCCESS,
		payload: response,
	};
};
export const POIacknowledge_open = (data) => {
	return {
		type: PO_ITEM_ACKNOWLEDGE_OPEN,
		payload: data,
	};
};
export const POIacknowledge_close = (POIacknowledge_Model) => {
	return {
		type: PO_ITEM_ACKNOWLEDGE_CLOSE,
		payload: { POIacknowledge_Model },
	};
};

export const POClose_modal_open = () => {
	return {
		type: PO_CLOSE_MODAL_OPEN,
	};
};

export const POClose_modal_close = () => {
	return {
		type: PO_CLOSE_MODAL_CLOSE,
	};
};
export const ToggleEdit = (poItemId) => {
	return {
		type: TOGGLE_EDIT,
		payload: poItemId,
	};
};
export const ToggleEditWithValue = (value) => {
	return {
		type: TOGGLE_EDIT_WITH_VALUE,
	};
};

export const POAcknowledgeInputChangeValue = ({ key, value }) => {
	return {
		type: PO_ITEM_INPUT_CHANGEVALUE,
		payload: { key, value },
	};
};

export const POCancelDescription = ({ key, value }) => {
	return {
		type: PO_CLOSE_DESCRIPTION,
		payload: { key, value },
	};
};
export const SubmitPOiacknowledge = (data) => {
	return {
		type: PO_ITEM_ACKNOWLEDGE,
		payload: { data },
	};
};

export const SubmitEditOrder = (order, id) => {
	const purchaseId = id;
	const reformatDate = (dateStr) => {
		const [day, month, year] = dateStr.split("-");
		return `${year}-${month}-${day}`;
	};

	const data = {
		comparequotation_id: order.comparequotation,
		location_id: order.location.id,
		sublocation_id: order.sublocation ? order.sublocation.id : null,
		requestforquotation_id: order.requestforquotation,
		quotation_id: order.quotation,
		vendor_id: order.vendor.id,
		deliverydate: order.deliverydate
			? reformatDate(order.deliverydate)
			: null,
		cost_center_type: order.cost_center_type,
		purchase_type: order.purchase_type,
		sublocation_id: order.sublocation?.id,
		poitems: order?.poitems?.map((item) => ({
			id: item.id,
			product_id: item.product.id,
			unit_id: item.unit.id,
			tax_id: item.tax.id,
			qitem_id: item.qitem,
			cqitem_id: item.cqitem,
			qty: item.qty,
			baseprice: item.baseprice,
			price: parseFloat(item.price).toFixed(2),
			taxamount: parseFloat(item.taxamount).toFixed(2),
			gross: parseFloat(item.gross).toFixed(2),
			discount: item.discount,
			discountpercent: item.discountpercent,
			description: item.description,
			date: item.date,
			make: item.make,
		})),
	};
	return {
		type: SUBMIT_EDIT_ORDER,
		payload: { data, purchaseId },
	};
};
export const SubmitEditOrderSuccessfull = () => {
	return {
		type: SUBMIT_EDIT_ORDER_SUCCESSFULL,
	};
};
export const listlayout = (layout) => {
	return {
		type: LIST_LAYOUT,
		payload: layout,
	};
};
export const FiltersShowRightSidebar = () => {
	return {
		type: FILTERS_SHOW_RIGHT_SIDEBAR,
		payload: null,
	};
};
export const viewLogShowRightSidebarPurchase = (purchaseId) => {
	return {
		type: VIEW_LOG_SHOW_RIGHT_SIDEBAR_PURCHASE,
		payload: { purchaseId },
	};
};
export const viewLogHideRightSidebarPurchase = (purchaseId) => {
	return {
		type: VIEW_LOG_HIDE_RIGHT_SIDEBAR_PURCHASE,
		payload: { purchaseId },
	};
};

export const FiltershideRightSidebar = () => ({
	type: FILTERS_HIDE_RIGHT_SIDEBAR,
	payload: null,
});
export const FilterClear = () => {
	return {
		type: CLEAR_FILTER,
		payload: null,
	};
};
export const getPDFDownload = (POId) => {
	return {
		type: PDF_DOWNNLOAD,
		payload: { POId },
	};
};
export const PurchaseOrderClose = (id, description) => {
	return {
		type: PURCHASE_ORDER_CLOSE,
		payload: { id, description },
	};
};
export const apiError = (error) => {
	return {
		type: API_ERROR,
		payload: error,
	};
};

export const PoFoucsPost = (id) => {
	return {
		type: PURCHASE_ORDER_FOUCS_POST,
		payload: { id },
	};
};
export const handleBasePrice = (data) => {
	return {
		type: HANDLE_BASE_PRICE,
		payload: { data },
	};
};

export const orderDiscountPercentChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: ORDER_DISC_PERCENT_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};
export const orderGrossValChangeValue = (taxamount, net, item) => {
	return {
		type: ITEM_GROSS_VAL_CHANGEVALUE,
		payload: { taxamount, net, item },
	};
};
export const orderBasePriceChangeValue = ({
	key,
	value,
	price,
	discount,
	item,
}) => {
	return {
		type: ORDER_BASEPRICE_CHANGEVALUE,
		payload: { key, value, price, discount, item },
	};
};
export const orderTaxTypeSelecteChangeValue = ({
	key,
	label,
	key2,
	value,
	item,
}) => {
	return {
		type: ORDER_TAXTYPE_CHANGEVALUE,
		payload: { key, label, key2, value, item },
	};
};

export const orderTaxSelecteChangeValue = ({ id, name, tax, item }) => {
	return {
		type: ORDER_TAX_CHANGEVALUE,
		payload: { id, name, tax, item },
	};
};
